module.exports = __webpack_public_path__ + "static/media/icon-star-active.bcc4a6dc.svg";